import styled from 'styled-components/macro';
import { inputStyles } from './form/inputs/inputStyles';
import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';

type Props = {
  $isValid?: boolean;
  $isInvalid?: boolean;
  $isSmall?: boolean;
};

const TextInputBase = (props: PropsWithChildren<ComponentPropsWithoutRef<'input'>>) => (
  <input {...props} onFocus={e => e.target.select()} />
);

export const TextInput = styled(TextInputBase).attrs(() => ({ type: 'text' }))<Props>`
  ${({ $isValid, $isInvalid, $isSmall }) => inputStyles({ $isValid, $isInvalid, $isSmall })};
`;
